import * as Yup from "yup";

const meioPagamentoValidator = Yup.object().shape({
  descricao: Yup.string().required("Descrição"),
  baixaAutomatica: Yup.boolean().nullable(),
  bancoCaixaId: Yup.number().required("Conta"),
  cartaoCreditoDebito: Yup.boolean().nullable(),
  gerarCheque: Yup.boolean().nullable(),
  conciliacaoAutomatica: Yup.boolean().nullable(),
  disponivelPdv: Yup.boolean().nullable(),
  gerarBoleto: Yup.boolean().nullable(),
  tefIntegrado: Yup.boolean().nullable(),
  imprimirComprovanteDebito: Yup.boolean().nullable(),
  modalidadeTef: Yup.number().when("tefIntegrado", {
    is: true,
    then: Yup.number().required("Modalidade TEF"),
    otherwise: Yup.number().nullable(),
  }),
  nfePagamento: Yup.string().required("Nfe Pagamento"),
  ativado: Yup.boolean().nullable(),
});

export default meioPagamentoValidator;
